import { Mapper } from '../../../../base/utils/mapper';
import { ReprocessDocumentsAttentionResponseModel } from '../../../../domain/models/consult/reprocess-documents-attention-response.model';
import { ReprocessDocumentsAttentionResponseEntity } from '../entities/reprocess-documents-attention-response.entity';
export class ReprocessAttentionsListImplementationRepositoryMapper extends Mapper<ReprocessDocumentsAttentionResponseEntity, ReprocessDocumentsAttentionResponseModel> {
    mapFrom(param: ReprocessDocumentsAttentionResponseEntity): ReprocessDocumentsAttentionResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: ReprocessDocumentsAttentionResponseModel): ReprocessDocumentsAttentionResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}
